// src/components/DashboardLayout.js
import React, { useContext } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';


function DashboardLayout() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      {/* Sidebar */}
      <aside style={styles.sidebar}>
        <h2 style={styles.logo}>Dashboard</h2>
        <nav style={styles.nav}>
          <Link to="/overview" style={styles.link}>Übersicht</Link>
          <Link to="/timetracking" style={styles.link}>Zeiterfassung</Link>
          <Link to="/entries" style={styles.link}>Stundenbuchungen</Link> {/* Neuer Link */}
          <Link to="/customers" style={styles.link}>Kunden</Link> {/* Neuer Link */}
          <Link to="/expensemanagement" style={styles.link}>Abrechnung</Link> {/* Neuer Link */}
          <Link to="/dashboardinfo" style={styles.link}>Statistiken</Link>
          <Link to="/reportview" style={styles.link}>Report</Link> {/* Neuer Link */}
          <Link to="/settings" style={styles.link}>Einstellungen</Link>
          
          {/*<Link to="/pivotreports" style={styles.link}>Pivot Reports</Link> {/* Neuer Link */}

        </nav>
        {/* Logout-Button am unteren Ende */}
        <div style={styles.logoutContainer}>
          <button onClick={handleLogout} style={styles.logoutBtn}>
            Logout
          </button>
        </div>
      </aside>

      {/* Hauptinhalt (Outlet rendert die verschachtelten Routen) */}
      <main style={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  sidebar: {
    width: '220px',
    backgroundColor: '#f8f8f8',
    borderRight: '1px solid #ddd',
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    justifyContent: 'space-between', // Um Logout unten zu platzieren
  },
  logo: {
    marginBottom: '2rem',
    textAlign: 'center',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  link: {
    textDecoration: 'none',
    color: '#333',
    padding: '0.5rem',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
  },
  logoutContainer: {
    marginTop: 'auto', // Positioniert den Logout-Button unten
  },
  logoutBtn: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: '#ef4444',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  main: {
    flex: 1,
    padding: '2rem',
  },
};

export default DashboardLayout;
